import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Other = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M11.333 5.6v4.8L8 12l-3.333-1.6V5.6L8 4l3.333 1.6ZM8 5.479l2 .96V9.56l-2 .96-2-.96V6.439l2-.96Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2 4.866c0-.527.31-1.004.792-1.218l4.666-2.074a1.333 1.333 0 0 1 1.084 0l4.666 2.074c.482.214.792.691.792 1.218v6.267c0 .527-.31 1.005-.792 1.219l-4.666 2.074a1.334 1.334 0 0 1-1.084 0l-4.666-2.074A1.333 1.333 0 0 1 2 11.133V4.866Zm10.667 0v6.267L8 13.208l-4.667-2.075V4.866L8 2.792l4.667 2.074Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Other;
